export default __webpack_public_path__ + "static/media/Rise_Intro.4d8c9268.mp4";